<template>
	<section class="grid-row" :class="[ 'mb-'+ mb, 'mt-'+ mt, type, wrap, setXlsCols, setXsCols, setXlCols, setLgCols, setMdCols, setSmCols,  setCols ]">
		<slot />
	</section>
</template>

<script>
	export default {
		name: 'grid-row',
		props:{
			mb: {
				type: String,
				required: false,
				default: '0',
			},
			mt: {
				type: String,
				required: false,
				default: '0',
			},
			type: {
				type: String,
				required: false,
			},
			wrap: {
				type: String,
				required: false,
				default: '',
			},
			cols: {
				type: String,
				required: false,
				default: 'not-defined',
			},
			xsCols: {
				type: String,
				required: false,
				default: '',
			},
			smCols: {
				type: String,
				required: false,
				default: '',
			},
			mdCols: {
				type: String,
				required: false,
				default: '',
			},
			lgCols: {
				type: String,
				required: false,
				default: '',
			},
			xlCols: {
				type: String,
				required: false,
				default: '',
			},
			xlsCols: {
				type: String,
				required: false,
				default: '',
			},
		},
		data() {
			return {
				setCols: this.cols ? 'max-cols-' + this.cols : '',
				setXsCols: this.xsCols ? 'max-xs-cols-' + this.xsCols : '',
				setSmCols: this.smCols ? 'max-sm-cols-' + this.smCols : '',
				setMdCols: this.mdCols ? 'max-md-cols-' + this.mdCols : '' ,
				setLgCols: this.lgCols ? 'max-lg-cols-' + this.lgCols : '',
				setXlCols: this.xlCols ? 'max-xl-cols-' + this.xlCols : '',
				setXlsCols: this.xlsCols ? 'max-xls-cols-' + this.xlsCols : '',
			}
		},
	
	};
</script>


